import QueryLimitReached from './QueryLimitReached';

export default QueryLimitReached;
